import { CompanySearchModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const defaultCompany: CompanySearchModelDto = {
    id: 0,
    companyGuidUniqueId: '',
};

export class CompanySearchResult extends DomainEntity<CompanySearchModelDto> {
    constructor(dto: CompanySearchModelDto) {
        super(dto);
        this.cifNumber = dto.cifNumber;
        this.name = dto.name;
        this.status = dto.status;
        this.taxNumber = dto.taxNumber;
        this.id = dto.id;
    }

    public id: number;

    public cifNumber?: string;

    /**
     * In practice, this value can be `null` for associated companies,
     * so we must make it a string so that it doesn't blow up the advanced table
     * during searches.
     */
    public readonly companyId = this.dto.companyId || '';

    public name?: string;

    public status?: string;

    public taxNumber?: string;

    public createDefault(): this {
        return new CompanySearchResult(defaultCompany) as this;
    }
}
